import React from 'react'
import type { Props } from './types'
import PremiumTag from '../../premium/Tag'

const TabGroup: React.FC<Props> = ({ tabs, handleClick, active }) => {
  const activeTabClasses = 'border-b-4 border-deep-green font-semibold text-deep-green'
  const inactiveTabClasses = 'border-b-2 border-gray-100 font-light text-black'
  const textAlign = tabs.length > 1 ? 'text-middle' : 'text-start'
  return (
    <div className='w-full flex mb-4 whitespace-nowrap overflow-auto hide-scrollbar'>
      {tabs.map((tab) => {
        const isActive = active === tab.id && tabs.length > 1
        return (
          <button
            className={`disabled:opacity-45 flex-1 px-3 py-2 ${textAlign} ${isActive || tabs.length == 1 ? activeTabClasses : inactiveTabClasses}`}
            key={tab.id}
            onClick={() => handleClick(tab.id)}
            disabled={tab.disabled}
          >
            <p className='text-xs sm:text-base'>{tab.title} {tab.isPremium && <PremiumTag size='sm' />}</p>
          </button>
        )
      })}
    </div>
  )
}

export default TabGroup
